<template lang="pug">
expand-menu(
  :type="MENU_TYPES.INDEPEND"
  top
  additional-menu-classes="rounded-12 redesign-box-shadow"
)
  template(#activator="{ on, attrs }")
    slot(name="activator" v-bind="{ on, attrs, title, currentValueText, hasSelectedValue, loading, isEditable }")
      v-sheet.d-flex.align-center.rounded-12.section-bg-current.pa-3(
        :class=`{
          'gap-8': $vuetify.breakpoint.smAndDown,
          'gap-16': $vuetify.breakpoint.mdAndUp,
        }`
      )
        div(v-if="isEditable")
          slot(name="success-icon" v-if="hasSelectedValue")
            v-icon(color="redesignSuccess") $icheck-all
          slot(name="error-icon" v-else)
            v-icon(color="redesignError") $iinfo
        slot(name="default" v-bind="{ title, currentValueText }")
          .d-flex.flex-column(
            :class=`{
              'gap-4': $vuetify.breakpoint.smAndDown,
              'gap-10': $vuetify.breakpoint.mdAndUp,
            }`
          )
            .weight-500(
              :class=`{
                'body-1': $vuetify.breakpoint.smAndDown,
                'title-1': $vuetify.breakpoint.mdAndUp,
              }`
            ) {{ title }}
            .weight-400.redesignSecondary--text(
              :class=`{
                'body-2': $vuetify.breakpoint.smAndDown,
                'body-1': $vuetify.breakpoint.mdAndUp,
              }`
            ) {{ currentValueText }}

        v-btn.ml-auto(
          v-if="isEditable"
          :loading="loading"
          icon
          color="redesignPrimaryDarken"
          v-on="on"
        )
          v-icon(:size="inputValue === null ? '24' : '22'") {{ inputValue === null ? '$iplus-outline' : '$ipencil' }}
  .redesign.d-flex.flex-column.full-width
    .pa-4.d-flex.justify-space-between.gap-20.align-center
      .weight-500.title-1(@click.stop) {{ title }}
      v-btn(
        color="redesignBlack"
        icon
        small
      )
        v-icon $iclose

    v-sheet.transparent.pr-4.mr-2.overflow-auto.redesign-scrollbar.mb-1(
      max-height="500px"
      max-width="600px"
    )
      app-radio-group(
        v-model="inputValue"
        :items="items"
        :keyValue="itemValue"
        :keyLabel="itemText"
        hide-details
        :container-props=`{
          class: 'pl-3',
        }`
      )
        template(#label="{ item }")
          p.body-1.my-3.word-break {{ item[itemText] }}

</template>

<script>
import ExpandMenu, { MENU_TYPES } from '@/components/user-redesign/ExpandMenu.vue';
import AppRadioGroup from '@/components/user-redesign/inputs/AppRadioGroup.vue';

export default {
  components: {
    ExpandMenu,
    AppRadioGroup,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemText: {
      type: String,
      default: 'name',
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      MENU_TYPES,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    currentValueText() {
      const item = this.items.find((arrayItem) => arrayItem[this.itemValue] === this.inputValue);
      return item && item[this.itemText] ? item[this.itemText] : 'Не выбрано';
    },
    hasSelectedValue() {
      return this.inputValue !== null;
    },
  },
};
</script>
